<template>
  <div id="groupList">
    <div id="messageGroupList" v-if="list">
      <v-container class="pa-0">
        <v-layout>
          <router-link to="/admin/messageGroup/add">
          <v-flex class="xs12 sm12 mb-5">
            <v-btn fab absolute right class="mr-3 pf-btn-fab">
              <v-icon>add</v-icon>
            </v-btn>
          </v-flex>
          </router-link>
        </v-layout> 
      </v-container>
      <v-card-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search by Group Name"
            single-line
            hide-details
          ></v-text-field>
      </v-card-title>
      <v-card class="mt-3">
        <v-data-table
          disable-initial-sort
          :headers="headers"
          :items="MessageGroup"
          :search="search"
          :pagination.sync="pagination"
          class="pf-data-table"
        >
          <template v-slot:items="props">
            <td>{{ props.item.name }}</td>
            <td v-html="getNames(props.item.human)"></td>
            <td>{{ formatDate(props.item.createdAt, 'MM/DD/YYYY') }}</td>
            <td align="right">
              <v-btn icon class="ma-0" @click="editItem(props.item, props.index)">
                <v-icon size="22" color="grey darken-2">edit</v-icon>
              </v-btn>
               <v-btn icon class="ma-0" @click="deleteItem(props.item, props.index)">
                <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <div v-if="!list">
      <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left @click="backToListing" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>          
        </v-flex>
      </v-layout>
    </v-container>  
    <v-form ref="formAdd">   
      <v-container class="-border">
        <v-layout wrap>
          <v-flex xs12 class="button-container pr-3 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="backToListing">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <v-layout>
            <v-flex class="xs12 sm6 md7">
            <v-text-field 
                label="Group Name" 
                v-model="editGroup.name" 
                class="required pr-4 pl-4" 
                @input="changedData" 
                :rules="[rules.NameRule]">
            </v-text-field>
            </v-flex>
        </v-layout>
        <v-layout v-if="editGroup.human.length" class="mr-4 ml-4">
          <v-flex class="xs12 sm6 md7 pa-0">
            <label>Selected Memebers</label>
            <template v-for="(to, i) in editGroup.human">
                <v-chip
                :key="i"
                v-if="true"
                class=""
                close
                @input="removeItem(to.id)"
                >
                {{ to.agency ? to.agency.name : to.name }}
                </v-chip>
          </template>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex class="xs12 sm6 md7">
              <v-autocomplete
                return-object
                v-model="editGroup.human"
                @change="changedData" 
                @keyup.enter="searchFamilies" 
                :items="recipientList" 
                item-text="name"
                item-value="id"
                label="search Members"
                :rules="[rules.toRule]"
                deletable-chips
                small-chips
                multiple
                hide-no-data
                placeholder="Search by Name / Nickname / PPN / Agency"
                hint="Type atleast 3 characters to search"
                id="recipientSearch"
                :search-input.sync="searchInput"
                class="required pr-4 pl-4">
                <v-icon slot="append" @click="searchFamilies"> search </v-icon>
              </v-autocomplete>
          </v-flex>
        </v-layout>
         <v-layout>
          <v-flex class="xs12 sm6 md7">
          <v-combobox class="pr-4 pl-4" persistent-hint :rules="[rules.multipleEmail]" @change="changedData" v-model="editGroup.emails" label="Emails" hint="emails - hit enter to add new" multiple deletable-chips small-chips></v-combobox>
          </v-flex>
        </v-layout>   
        <v-layout class="editor-button-container">
          <v-flex xs12 class="button-container pr-3 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="backToListing">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    </div>
  </div>
</template>
<script>
/* global session store config */
import { getCollection, update, remove, formatDate } from '../../helpers/helpers';
import { mapGetters } from 'vuex';
import swal from 'sweetalert2';

// This lists the message Group to the admin
export default {
  name: 'messageGroupList',
  data: () => ({
    entity: 'MessageGroup',
    selectedData: false,
    editGroup: {},
    searchInput: '',
    group: {
      name: '',
      human: [],
      emails: []
    },
    query: {
      family: ''
    },
    recipientList: [],
    familyResult: [],
    agencyResult: [],
    conversationIndex: '',
    rules: {
      NameRule: (v) => !!v || 'Please enter Group Name',
      toRule: (v) => !!(v && v.length) || 'Please select recipient',
      multipleEmail: (v) => v === undefined || v.length === 0 || /^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},?)+$/.test(v) || 'Please enter valid email address'
    },    
    list: true,
    search: '',
    messageGroup: {},
    messageGroupList: [],
    editIndex: -1,
    pagination: {
      sortBy: 'createdAt', // The field that you're sorting by
      descending: false,
      rowsPerPage: config.dom.rowsPerPage
    },
    familyList: [],
    headers: [
      { text: 'Name', value: 'name', align: 'left' },
      { text: 'Members', value: 'human' },
      { text: 'Created', value: 'createdAt', width: '160px' },
      { text: '', width: '160px', sortable: false }
    ]
  }),
  computed: {
    ...mapGetters(['Agency', 'MessageGroup']),
    AgencyList: {
      set (value) {
        store.commit('setAgencyList', value);
      },
      get () {
        return store.state.AgencyList;
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    this.initialize();
    this.initializeAgencyList();
  },
  methods: {
    getNames (list) {
      return list.map(human => (human.agency ? human.agency.name : human.name)).join(', <br/>');
    },
    // @vuese
    // Used to format the mongo date string
    // @arg The mongo date string
    formatDate (dateString) {
      if (dateString) {
        return formatDate(dateString, 'MM/DD/YYYY');
      }
    },
    // @vuese
    // Used to show the form buttons
    changedData () {
      this.selectedData = true;
    },
    // @vuese
    // Used to hide the form buttons
    hideButtons () {
      window.getApp.$emit('pageSubHeader', '');
      this.selectedData = false;
      this.list = true;
    },
    deleteItem (item, index) {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let { error, data, status } = await remove(this.entity, item.id);
            if (error) {
              console.log('error', error);
            } else {
              this.MessageGroup.splice(index, 1);
              console.table(this.MessageGroup);
              swal.fire(
                'Deleted!',
                `"${item.name}" has been deleted.`,
                'success'
              );
            }
          })();
        }
      });
    },
    // @vuese
    // Used to go back to the survey list
    backToListing () {
      window.getApp.$emit('pageSubHeader', '');
      this.list = true;
      this.editIndex = -1;
      this.survey = {};
    },
    // @vuese
    // Used to fetch the group list if not exists
    async initialize () {
      if (!this.MessageGroup.length) {
        let { error, data } = await getCollection(this.entity, true);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            store.commit('setMessageGroup', data);
          }
        }
      }
    },
    removeItem (id) {
      this.selectedData = true;
      this.editGroup.human = this.editGroup.human.filter(user => user.id !== id);
    },
    async save () {
      if (this.$refs.formAdd.validate()) {
        this.editGroup.human = this.editGroup.human.map(user => user.id);
        this.selectedData = false;
        let postDate = {
          human: this.editGroup.human,
          emails: this.editGroup.emails,
          name: this.editGroup.name
        };
        let { error, data, status } = await update(this.entity, postDate, this.editGroup.id);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
        } else {
          this.MessageGroup[this.editIndex] = data;
          this.loading = false;
          swal.fire({
            type: 'success',
            title: 'Message Group updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.editIndex = -1;
              this.list = true;
              this.editGroup = {};
              window.getApp.$emit('pageSubHeader', '');
            }
          });
        }
      }
    },
    // @vuese
    // Used to search for recipients on entering family name, nickname, PPN or the agency name
    // @arg The keyup event object
    async initializeAgencyList () {
      if (!this.AgencyList.length) {
        let where = { _id: { $ne: this.Agency.id }};
        let attributes = 'name,createdAt,_id,is_admin,avatar';
        let populate = [{ path: 'human', select: '_id name user' }];
        let { error, data } = await getCollection('Agency', true, 0, populate, where, attributes);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load client list'
          };
        } else {
          if (data.length > 0) {
            store.commit('setAgencyList', data);
          }
        }
      }
    },
    async searchFamilies () {
      this.recipientList = [];
      this.familyResult = [];
      this.agencyResult = [];
      this.query.family = this.searchInput;
      let profile_number = this.query.family;
      let profile_year = this.query.family;
      if (this.query.family && this.query.family.length > 2) {
        let where = { };
        if (this.query.family && this.query.family.length) {
          if (!where.$or) {
            where.$or = [{
              $expr: {
                $eq: [this.query.family, {
                  $concat: [{
                    '$toString': '$profile_year'
                  }, '_', {
                    '$toString': '$profile_number'
                  }]
                }]
              }
            }, {
              'nickname': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            }, {
              'name': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            }];
          } else {
            where.$or.push({
              $expr: {
                $eq: [this.query.family, {
                  $concat: [{
                    '$toString': '$profile_year'
                  }, '_', {
                    '$toString': '$profile_number'
                  }]
                }]
              }
            });
            where.$or.push({
              'nickname': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            });
            where.$or.push({
              'name': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            });
          }
        }
        if (this.query.family && !isNaN(this.query.family)) {
          where.$or.push({
            'profile_number': this.query.family
          });
        }
        if (this.query.status) {
          where.profile_status = this.query.status;
        }
        let populate = [{ 'path': 'human' }, 'contactInfo.country', 'contactInfo.state'];
        let { error, data } = await getCollection('Account', true, 0, populate, where);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load client list'
          };
        } else {
          if (data.length > 0) {
            this.recipientList = data;
            this.agencyFilter();
          } else {
            this.agencyFilter();
          }
        }
      }
    },
    async agencyFilter () {
      console.log(this.query.family);
      if (this.query.family && this.query.family.length > 2) {
        let filteredList = this.AgencyList.filter((element) => {
          if (element.name.toLowerCase().includes(this.query.family.toLowerCase())) {
            return element;
          }
          return false;
        });
        if (this.recipientList.length) {
          this.recipientList.forEach(item => {
            let obj = {};
            if (item.nickname.toLowerCase().includes(this.searchInput.toLowerCase())) {
              obj = {
                name: item.nickname,
                id: item.human[0].id
              };
            } else {
              let text = '';
              if (item.ppn === this.searchInput) {
                text = `${item.ppn} / ${item.name}`;
              } else {
                text = item.name;
              }
              obj = {
                name: text,
                id: item.human[0].id
              };
            }
            this.familyResult.push(obj);
          });
        }
        if (filteredList.length) {
          filteredList.forEach(item => {
            let obj = {
              name: item.name,
              id: item.human[0].id
            };
            this.agencyResult.push(obj);
          });
        }
        this.recipientList = [...this.familyResult, ...this.agencyResult];
      }
    },
    editItem (item) {
      this.editIndex = this.MessageGroup.indexOf(item);
      this.list = false;
      this.editGroup = JSON.parse(JSON.stringify(item));
      window.getApp.$emit('pageSubHeader', 'Edit');
    },
  }
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Messages/group_list.vue